/**
 * Build-time feature flags (Vite inlines `import.meta.env.VITE_*` at build time).
 */

/**
 * Akustične (A4) is hidden until its audio ships: set `VITE_FEATURE_ACOUSTIC=true`
 * at build time to show the nav item and the /acoustic route. Off by default.
 */
export function isAcousticEnabled(): boolean {
  return import.meta.env.VITE_FEATURE_ACOUSTIC === 'true';
}
